// translations.js
export const translations = {
  pl: {
    // Hero
    'hero.label': 'Senior Developer',
    'hero.name': 'Marcin Galej',
    'hero.title': 'Senior Backend / Full-Stack Developer',
    'hero.tagline': 'Ponad dekada doświadczenia w budowaniu platform e-commerce i aplikacji enterprise obsługujących miliony użytkowników',
    'hero.cta': 'Poznaj mnie',

    // Navigation
    'nav.home': 'Start',

    // About
    'about.label': 'O mnie',
    'about.heading': 'Kim jestem',
    'about.subtitle': 'Architekt Rozwiązań Backend i Full-Stack',
    'about.text1': 'Specjalizuję się w projektowaniu, rozwijaniu i utrzymaniu skalowalnych systemów webowych, które wspierają rozwój biznesu i obsługują miliony użytkowników dziennie.',
    'about.text2': 'Mój główny stack to PHP (Laravel, Symfony) oraz .NET Core. Pracowałem przy platformach e-commerce (PrestaShop, Sylius), dedykowanych CMS-ach i CRM-ach, a także przy aplikacjach przetwarzających bardzo duże wolumeny danych.',
    'about.text3': 'Posiadam praktyczne doświadczenie w Flutterze, co pozwala mi patrzeć na produkt całościowo — od architektury danych po interfejs użytkownika. W codziennej pracy zwracam dużą uwagę na czytelną architekturę, utrzymywalność kodu i świadome stosowanie zasad Clean Architecture.',

    // Stats
    'stats.years': '10+',
    'stats.years.label': 'Lat doświadczenia',
    'stats.tech': '25+',
    'stats.tech.label': 'Technologii',
    'stats.code': '50+',
    'stats.code.label': 'Projektów',

    // Expertise
    'expertise.label': 'Specjalizacja',
    'expertise.heading': 'W czym jestem najlepszy',
    'expertise.description': 'Trzy główne obszary, w których mam największe doświadczenie i osiągam najlepsze rezultaty',

    'expertise.backend.title': 'Backend Development',
    'expertise.backend.description': 'Projektowanie i implementacja skalowalnych systemów backendowych w PHP i .NET Core',
    'expertise.backend.item1': 'RESTful API & GraphQL',
    'expertise.backend.item2': 'Mikrousługi',
    'expertise.backend.item3': 'Integracje zewnętrzne',

    'expertise.architecture.title': 'Architektura & Wydajność',
    'expertise.architecture.description': 'Optymalizacja systemów przetwarzających duże wolumeny danych i projektowanie architektury',
    'expertise.architecture.item1': 'Clean Architecture',
    'expertise.architecture.item2': 'Optymalizacja SQL',
    'expertise.architecture.item3': 'Cache & Kolejki',

    'expertise.fullstack.title': 'Full-Stack Solutions',
    'expertise.fullstack.description': 'Kompleksowe rozwiązania od backendu po aplikacje mobilne i desktopowe',
    'expertise.fullstack.item1': 'E-commerce platforms',
    'expertise.fullstack.item2': 'CMS & CRM',
    'expertise.fullstack.item3': 'Flutter apps',

    // Tech Stack
    'tech.label': 'Technologie',
    'tech.heading': 'Stack technologiczny',
    'tech.description': 'Zaawansowane narzędzia i technologie, które wykorzystuję do budowania skalowalnych rozwiązań',
    // Tech Stack Slider
    'slider.benefits': 'Kluczowe korzyści:',
    'slider.backend.title': 'High-Performance APIs',
    'slider.backend.desc': 'Projektowanie i wdrażanie wysokowydajnych interfejsów API zdolnych do obsługi milionów żądań dziennie przy minimalnych opóźnieniach.',
    'slider.backend.benefit1': 'Redukcja czasu odpowiedzi systemu o 40-60%',
    'slider.backend.benefit2': 'Bezpieczna integracja z systemami bankowymi i płatniczymi',
    'slider.backend.benefit3': 'Pełna skalowalność horyzontalna w chmurze',

    'slider.frontend.title': 'Responsive Web Interfaces',
    'slider.frontend.desc': 'Tworzenie nowoczesnych, responsywnych interfejsów użytkownika z naciskiem na wydajność i dostępność.',
    'slider.frontend.benefit1': 'Optymalna wydajność na wszystkich urządzeniach',
    'slider.frontend.benefit2': 'Intuicyjny UX zwiększający konwersję',
    'slider.frontend.benefit3': 'Zgodność z WCAG i standardami SEO',

    'slider.data.title': 'Big Data Processing',
    'slider.data.desc': 'Tworzenie zaawansowanych potoków przetwarzania danych (ETL) i systemów analitycznych działających w czasie rzeczywistym.',
    'slider.data.benefit1': 'Analiza zachowań użytkowników w czasie rzeczywistym',
    'slider.data.benefit2': 'Personalizacja treści oparta na danych',
    'slider.data.benefit3': 'Optymalizacja kosztów infrastruktury dzięki wydajnym algorytmom',

    'slider.ecommerce.title': 'Enterprise E-commerce',
    'slider.ecommerce.desc': 'Budowa dedykowanych platform sprzedażowych B2B i B2C dostosowanych do specyficznych procesów biznesowych klienta.',
    'slider.ecommerce.benefit1': 'Automatyzacja procesów logistycznych i magazynowych',
    'slider.ecommerce.benefit2': 'Wsparcie dla wielu rynków, walut i stref podatkowych',
    'slider.ecommerce.benefit3': 'Odporność na piki ruchu (np. Black Friday)',

    'slider.mobile.title': 'Multi-Platform Mobile',
    'slider.mobile.desc': 'Wydajne aplikacje natywne i hybrydowe, zapewniające spójne doświadczenie użytkownika na systemach iOS i Android.',
    'slider.mobile.benefit1': 'Skrócony czas wdrożenia (Time-to-Market) o 50%',
    'slider.mobile.benefit2': 'Spójny design system na wszystkich platformach',
    'slider.mobile.benefit3': 'Jedna baza kodu redukująca koszty utrzymania',

    'slider.architecture.title': 'Scalable Architecture',
    'slider.architecture.desc': 'Projektowanie systemów rozproszonych i mikroserwisów z naciskiem na niezawodność, łatwość utrzymania i przyszły rozwój.',
    'slider.architecture.benefit1': 'Eliminacja długu technologicznego',
    'slider.architecture.benefit2': 'Łatwe wdrażanie nowych funkcjonalności (CI/CD)',
    'slider.architecture.benefit3': 'Wysoka dostępność (High Availability) 99.9%',


    // Contact
    'contact.label': 'Kontakt',
    'contact.heading': 'Porozmawiajmy o Twoim projekcie',
    'contact.description': 'Jestem otwarty na wyzwania technologiczne. Skontaktuj się ze mną, aby omówić szczegóły.',
    'contact.email': 'Email',
    'contact.github': 'GitHub',
    'contact.linkedin': 'LinkedIn',
    'contact.form.name': 'Imię',
    'contact.form.email': 'Email',
    'contact.form.subject': 'Temat',
    'contact.form.message': 'Wiadomość',
    'contact.form.submit': 'Wyślij wiadomość',
    'contact.form.sending': 'Wysyłanie...',
    'contact.form.success': 'Wiadomość wysłana! Dziękuję za kontakt.',
    'contact.form.error': 'Wystąpił błąd. Spróbuj ponownie.',
    'contact.form.errors.name': 'Wprowadź imię (min. 2 znaki)',
    'contact.form.errors.email': 'Wprowadź poprawny adres email',
    'contact.form.errors.subject': 'Wprowadź temat (min. 3 znaki)',
    'contact.form.errors.message': 'Wprowadź wiadomość (min. 10 znaków)',
    'contact.social.heading': 'Znajdź mnie',
    'contact.social.responseTime': 'Zazwyczaj odpowiadam w ciągu 24-48 godzin',

    // Case Studies
    'casestudies.label': 'Portfolio',
    'casestudies.heading': 'Wybrane Projekty',
    'casestudies.description': 'Przykłady zrealizowanych rozwiązań i systemów, które przyniosły realne korzyści biznesowe',
    'casestudies.challenge': 'Wyzwanie',
    'casestudies.solution': 'Rozwiązanie',
    'casestudies.results': 'Rezultaty',
    'casestudies.scale': 'Skala projektu',

    // Case 1: ERP
    'portfolio.case1.badge': 'System ERP',
    'portfolio.case1.title': 'System Zarządzania Projektami i Pracownikami',
    'portfolio.case1.challenge': 'Firma budowlana potrzebowała centralnego systemu do zarządzania projektami w 15+ krajach, pracownikami oraz czasem pracy, aby wyeliminować ręczne procesy i błędy.',
    'portfolio.case1.solution': 'Zaprojektowałem i wdrożyłem modularną aplikację webową (Symfony) z modułem RCP, obiegiem dokumentów, powiadomieniami i zaawansowanym raportowaniem.',
    'portfolio.case1.result1': 'Skrócenie czasu rozliczeń o 50% dzięki automatyzacji',
    'portfolio.case1.result2': 'Pełna centralizacja danych z 15 krajów',
    'portfolio.case1.result3': 'Eliminacja strat dzięki kontroli kosztów w czasie rzeczywistym',

    // Case 2: E-commerce Auto
    'portfolio.case2.badge': 'E-commerce',
    'portfolio.case2.title': 'System E-commerce dla Branży Motoryzacyjnej',
    'portfolio.case2.challenge': 'Przetwarzanie i aktualizacja 5 mln+ produktów w czasie rzeczywistym, zarządzanie cenami i integracja z wieloma dostawcami.',
    'portfolio.case2.solution': 'Wydajny backend (Laravel + Solr) z architekturą kolejkową, automatyzacją cen i mapowaniem produktów z hurtowni.',
    'portfolio.case2.result1': 'Obsługa katalogu 5 mln+ produktów',
    'portfolio.case2.result2': 'Automatyczna aktualizacja cen i stanów co 15 minut',
    'portfolio.case2.result3': 'Skalowalność na nowe rynki i platformy marketplace',

    // Case 3: CRM Real-Time
    'portfolio.case3.badge': 'Real-Time CRM',
    'portfolio.case3.title': 'CRM Real-Time do Monitorowania Projektów',
    'portfolio.case3.challenge': 'Brak wglądu w postępy prac w czasie rzeczywistym dla 5000+ pracowników i opóźnienia w raportowaniu.',
    'portfolio.case3.solution': 'System Event-Driven (.NET Core + RabbitMQ) z aplikacją mobilną Flutter do raportowania zdarzeń z terenu.',
    'portfolio.case3.result1': 'Monitoring postępów w czasie rzeczywistym',
    'portfolio.case3.result2': 'Natychmiastowe wykrywanie opóźnień i problemów',
    'portfolio.case3.result3': 'Jeden kod (Flutter) dla Android, iOS i Web',

    // Case 4: CMS Agency
    'portfolio.case4.badge': 'CMS Platform',
    'portfolio.case4.title': 'Modularny CMS dla Agencji Interaktywnej',
    'portfolio.case4.challenge': 'Długi czas tworzenia dedykowanych stron dla klientów i trudności w zarządzaniu wieloma instancjami.',
    'portfolio.case4.solution': 'Autorski, modularny CMS pozwalający budować strony z gotowych bloków z centralnym panelem zarządzania.',
    'portfolio.case4.result1': 'Skrócenie czasu wdrożenia strony z dni do godzin',
    'portfolio.case4.result2': 'Łatwe zarządzanie 30+ stronami z jednego miejsca',
    'portfolio.case4.result3': 'Automatyzacja SEO i optymalizacji treści',

    // Case 5: Investment PWA
    'portfolio.case5.badge': 'FinTech PWA',
    'portfolio.case5.title': 'Platforma Inwestycyjna PWA',
    'portfolio.case5.challenge': 'Usprawnienie procesu onboardingu inwestorów, obsługa dokumentów i płatności (w tym kryptowalut).',
    'portfolio.case5.solution': 'Aplikacja PWA (Symfony + Angular) z automatycznym procesem KYC, obsługą płatności i panelem inwestora.',
    'portfolio.case5.result1': 'Pełna automatyzacja obsługi inwestorów',
    'portfolio.case5.result2': 'Bezpieczna obsługa płatności BTC i fiat',
    'portfolio.case5.result3': 'Dostępność na każdym urządzeniu (mobile/desktop)',

    // Case 6: Medical E-commerce
    'portfolio.case6.badge': 'Medical E-commerce',
    'portfolio.case6.title': 'Sklep Medyczny z Integracją NFZ',
    'portfolio.case6.challenge': 'Specyficzne wymogi sprzedaży wyrobów medycznych, obsługa refundacji NFZ i integracja z Subiekt GT.',
    'portfolio.case6.solution': 'Dedykowane wdrożenie Sylius z modułami obsługi wniosków refundacyjnych i dwukierunkową synchronizacją ERP.',
    'portfolio.case6.result1': 'Automatyzacja procesów refundacji NFZ',
    'portfolio.case6.result2': 'Pełna integracja stanów i zamówień z Subiekt GT',
    'portfolio.case6.result3': 'Zgodność z rygorystycznymi wymogami prawnymi',

    // Case 7: Mailing System
    'portfolio.case7.badge': 'High-Load System',
    'portfolio.case7.title': 'System Masowej Wysyłki Mailingowej',
    'portfolio.case7.challenge': 'Problemy wydajnościowe przy wysyłce milionów wiadomości, przestarzała technologia i wolne raportowanie.',
    'portfolio.case7.solution': 'Modernizacja do PHP 7, optymalizacja bazy danych i wprowadzenie zaawansowanego kolejkowania wysyłek.',
    'portfolio.case7.result1': 'Stabilna obsługa kampanii >1 mln odbiorców',
    'portfolio.case7.result2': 'Raportowanie statystyk w czasie rzeczywistym',
    'portfolio.case7.result3': 'Znacząca redukcja obciążenia serwerów',

    // Case 8: AdTech
    'portfolio.case8.badge': 'AdTech & Big Data',
    'portfolio.case8.title': 'Platforma Zarządzania Kampaniami Analityki',
    'portfolio.case8.challenge': 'Agregacja i analiza ogromnych ilości danych o zdarzeniach reklamowych z wielu źródeł w czasie rzeczywistym.',
    'portfolio.case8.solution': 'Skalowalna platforma oparta o Hadoop i Solr do przetwarzania Big Data oraz integracje z giełdami reklam.',
    'portfolio.case8.result1': 'Przetwarzanie dziesiątek milionów zdarzeń dziennie',
    'portfolio.case8.result2': 'Precyzyjne targetowanie reklam',
    'portfolio.case8.result3': 'Optymalizacja budżetów reklamowych w czasie rzeczywistym',

    // Filters
    'portfolio.filter.all': 'Wszystkie',
    'portfolio.filter.backend': 'Backend',
    'portfolio.filter.frontend': 'Frontend',
    'portfolio.filter.mobile': 'Mobile',
    'portfolio.filter.database': 'Bazy Danych',
    'portfolio.filter.ecommerce': 'E-commerce',

    // Workflow
    'workflow.label': 'Proces',
    'workflow.heading': 'Jak Pracuję',
    'workflow.description': 'Sprawdzony proces realizacji projektu — od analizy po wdrożenie i wsparcie',
    'workflow.step1.title': 'Analiza i Wymagania',
    'workflow.step1.desc': 'Rozmowa z klientem, zrozumienie celu biznesowego, analiza procesów i przepływów danych.',
    'workflow.step1.output': '→ Dokument wymagań + plan funkcjonalny',
    'workflow.step2.title': 'Projekt Architektury',
    'workflow.step2.desc': 'Dobór technologii do potrzeb projektu, projekt struktury bazy danych, API i modułów.',
    'workflow.step2.output': '→ Architektura systemu + backlog techniczny',
    'workflow.step3.title': 'Implementacja',
    'workflow.step3.desc': 'Tworzenie backendu i API, budowa interfejsu użytkownika, integracje z usługami zewnętrznymi.',
    'workflow.step3.output': '→ Działająca wersja aplikacji (MVP)',
    'workflow.step4.title': 'Testy i Optymalizacja',
    'workflow.step4.desc': 'Testy manualne i automatyczne, testy wydajnościowe, poprawki i optymalizacje.',
    'workflow.step4.output': '→ Stabilna wersja produkcyjna',
    'workflow.step5.title': 'Wdrożenie',
    'workflow.step5.desc': 'Konfiguracja środowiska, migracje danych, uruchomienie aplikacji, monitoring i logowanie.',
    'workflow.step5.output': '→ Aplikacja dostępna dla użytkowników',
    'workflow.step6.title': 'Utrzymanie i Rozwój',
    'workflow.step6.desc': 'Poprawki i aktualizacje, rozwój nowych funkcji, analiza danych i optymalizacja.',
    'workflow.step6.output': '→ System rosnący wraz z biznesem',

    // Services
    'services.label': 'Oferta',
    'services.heading': 'Usługi',
    'services.description': 'Kompleksowe usługi programistyczne dopasowane do potrzeb Twojego biznesu',
    'services.webapp.title': 'Aplikacje Webowe',
    'services.webapp.desc': 'Dedykowane systemy CMS, CRM, panele administracyjne i aplikacje biznesowe.',
    'services.api.title': 'Tworzenie API',
    'services.api.desc': 'RESTful API i GraphQL do komunikacji między systemami, integracje z platformami.',
    'services.integration.title': 'Integracje Systemów',
    'services.integration.desc': 'Połączenie istniejących narzędzi, synchronizacja danych, automatyzacja przepływów.',
    'services.mobile.title': 'Aplikacje Mobilne',
    'services.mobile.desc': 'Cross-platform aplikacje na iOS i Android w Flutter z jednego kodu źródłowego.',
    'services.automation.title': 'Automatyzacja Procesów',
    'services.automation.desc': 'Skrypty i narzędzia automatyzujące powtarzalne zadania i usprawniające workflow.',
    'services.consulting.title': 'Konsultacje Techniczne',
    'services.consulting.desc': 'Analiza architektury, code review, dobór technologii, wsparcie w planowaniu projektów IT.',

    // Footer
    'footer.text': '© 2025 Marcin Galej. Wszelkie prawa zastrzeżone.',
    'footer.console.status': '"Gotowy do działania"'
  },

  en: {
    // Hero
    'hero.label': 'Senior Developer',
    'hero.name': 'Marcin Galej',
    'hero.title': 'Senior Backend / Full-Stack Developer',
    'hero.tagline': 'Over a decade of experience building e-commerce platforms and enterprise applications serving millions of users',
    'hero.cta': 'Get to know me',

    // Navigation
    'nav.home': 'Home',

    // About
    'about.label': 'About',
    'about.heading': 'Who I am',
    'about.subtitle': 'Backend & Full-Stack Solutions Architect',
    'about.text1': 'I specialize in designing, developing, and maintaining scalable web systems that drive business growth and serve millions of users daily.',
    'about.text2': 'My main stack is PHP (Laravel, Symfony) and .NET Core. I have worked on e-commerce platforms (PrestaShop, Sylius), custom CMS and CRM systems, as well as applications processing very large data volumes.',
    'about.text3': 'I have practical experience with Flutter, which allows me to view products holistically — from data architecture to user interface. In my daily work, I pay great attention to clean architecture, code maintainability, and conscious application of Clean Architecture principles.',

    // Stats
    'stats.years': '10+',
    'stats.years.label': 'Years of Experience',
    'stats.tech': '25+',
    'stats.tech.label': 'Technologies',
    'stats.code': '50+',
    'stats.code.label': 'Projects Delivered',

    // Expertise
    'expertise.label': 'Expertise',
    'expertise.heading': 'Core Competencies',
    'expertise.description': 'Three main areas where I deliver the most value and technical excellence',

    'expertise.backend.title': 'Backend Development',
    'expertise.backend.description': 'Designing and implementing scalable backend systems in PHP and .NET Core',
    'expertise.backend.item1': 'RESTful API & GraphQL',
    'expertise.backend.item2': 'Microservices Architecture',
    'expertise.backend.item3': 'Third-party Integrations',

    'expertise.architecture.title': 'Architecture & Performance',
    'expertise.architecture.description': 'Optimizing high-load systems and designing robust software architecture',
    'expertise.architecture.item1': 'Clean Architecture Principles',
    'expertise.architecture.item2': 'Database Optimization',
    'expertise.architecture.item3': 'Caching & Message Queues',

    'expertise.fullstack.title': 'Full-Stack Solutions',
    'expertise.fullstack.description': 'End-to-end solutions from backend logic to mobile and web interfaces',
    'expertise.fullstack.item1': 'E-commerce Platforms',
    'expertise.fullstack.item2': 'Custom CMS & CRM',
    'expertise.fullstack.item3': 'Cross-platform Apps',

    // Tech Stack
    'tech.label': 'Technologies',
    'tech.heading': 'Tech Stack',
    'tech.description': 'Advanced tools and technologies used to build scalable solutions',
    // Tech Stack Slider
    'slider.benefits': 'Key Benefits:',
    'slider.backend.title': 'High-Performance APIs',
    'slider.backend.desc': 'Designing and deploying high-throughput APIs capable of handling millions of requests with minimal latency.',
    'slider.backend.benefit1': 'Reduced system response time by 40-60%',
    'slider.backend.benefit2': 'Secure integration with banking and payment systems',
    'slider.backend.benefit3': 'Full horizontal scalability in the cloud',

    'slider.frontend.title': 'Responsive Web Interfaces',
    'slider.frontend.desc': 'Building modern, responsive user interfaces with focus on performance and accessibility.',
    'slider.frontend.benefit1': 'Optimal performance across all devices',
    'slider.frontend.benefit2': 'Intuitive UX increasing conversion rates',
    'slider.frontend.benefit3': 'WCAG compliance and SEO best practices',

    'slider.data.title': 'Big Data Processing',
    'slider.data.desc': 'Building advanced data processing pipelines (ETL) and real-time analytics systems.',
    'slider.data.benefit1': 'Real-time user behavior analytics',
    'slider.data.benefit2': 'Data-driven content personalization',
    'slider.data.benefit3': 'Infrastructure cost optimization via efficient algorithms',

    'slider.ecommerce.title': 'Enterprise E-commerce',
    'slider.ecommerce.desc': 'Developing custom B2B and B2C sales platforms tailored to specific business processes.',
    'slider.ecommerce.benefit1': 'Automation of logistics and warehouse processes',
    'slider.ecommerce.benefit2': 'Support for multiple markets, currencies, and tax zones',
    'slider.ecommerce.benefit3': 'Resilience to high traffic peaks (e.g., Black Friday)',

    'slider.mobile.title': 'Multi-Platform Mobile',
    'slider.mobile.desc': 'Efficient native and hybrid applications ensuring consistent user experience on iOS and Android.',
    'slider.mobile.benefit1': 'Reduced Time-to-Market by 50%',
    'slider.mobile.benefit2': 'Consistent design system across all platforms',
    'slider.mobile.benefit3': 'Single codebase reducing maintenance costs',

    'slider.architecture.title': 'Scalable Architecture',
    'slider.architecture.desc': 'Designing distributed systems and microservices with a focus on reliability, maintainability, and future growth.',
    'slider.architecture.benefit1': 'Elimination of technical debt',
    'slider.architecture.benefit2': 'Seamless feature deployment (CI/CD)',
    'slider.architecture.benefit3': 'High Availability (HA) at 99.9%',


    // Contact
    'contact.label': 'Contact',
    'contact.heading': "Let's discuss your project",
    'contact.description': 'I am open to technical challenges. Contact me to discuss details.',
    'contact.email': 'Email',
    'contact.github': 'GitHub',
    'contact.linkedin': 'LinkedIn',
    'contact.form.name': 'Name',
    'contact.form.email': 'Email',
    'contact.form.subject': 'Subject',
    'contact.form.message': 'Message',
    'contact.form.submit': 'Send Message',
    'contact.form.sending': 'Sending...',
    'contact.form.success': 'Message sent! Thank you for contacting me.',
    'contact.form.error': 'An error occurred. Please try again.',
    'contact.form.errors.name': 'Please enter your name (min. 2 chars)',
    'contact.form.errors.email': 'Please enter a valid email address',
    'contact.form.errors.subject': 'Please enter a subject (min. 3 chars)',
    'contact.form.errors.message': 'Please enter a message (min. 10 chars)',
    'contact.social.heading': 'Find me',
    'contact.social.responseTime': 'I usually reply within 24-48 hours',

    // Case Studies
    'casestudies.label': 'Portfolio',
    'casestudies.heading': 'Featured Projects',
    'casestudies.description': 'Examples of implemented solutions and systems that delivered real business value',
    'casestudies.challenge': 'Challenge',
    'casestudies.solution': 'Solution',
    'casestudies.results': 'Results',
    'casestudies.scale': 'Project Scale',

    // Case 1: ERP
    'portfolio.case1.badge': 'ERP System',
    'portfolio.case1.title': 'Project and Employee Management System',
    'portfolio.case1.challenge': 'Construction company needed a central system for managing projects in 15+ countries, employees, and time tracking to eliminate manual processes.',
    'portfolio.case1.solution': 'Designed and deployed a modular web app (Symfony) with time tracking, document workflow, notifications, and advanced reporting.',
    'portfolio.case1.result1': 'Billing process time reduced by 50% via automation',
    'portfolio.case1.result2': 'Full data centralization spanning 15 countries',
    'portfolio.case1.result3': 'Loss elimination through real-time cost control',

    // Case 2: E-commerce Auto
    'portfolio.case2.badge': 'E-commerce',
    'portfolio.case2.title': 'Automotive Industry E-commerce System',
    'portfolio.case2.challenge': 'Processing and updating 5M+ products in real-time, managing pricing policies, and integrating with multiple suppliers.',
    'portfolio.case2.solution': 'High-performance backend (Laravel + Solr) with queue architecture, automated pricing, and product mapping.',
    'portfolio.case2.result1': 'Handling a catalog of over 5 million products',
    'portfolio.case2.result2': 'Automated price and stock updates every 15 minutes',
    'portfolio.case2.result3': 'Scalability for new markets and marketplaces',

    // Case 3: CRM Real-Time
    'portfolio.case3.badge': 'Real-Time CRM',
    'portfolio.case3.title': 'Real-Time Project Monitoring CRM',
    'portfolio.case3.challenge': 'Lack of real-time visibility into work progress for 5000+ employees and reporting delays.',
    'portfolio.case3.solution': 'Event-Driven System (.NET Core + RabbitMQ) with Flutter mobile app for field event reporting.',
    'portfolio.case3.result1': 'Real-time progress monitoring',
    'portfolio.case3.result2': 'Immediate detection of delays and issues',
    'portfolio.case3.result3': 'Single codebase (Flutter) for Android, iOS, and Web',

    // Case 4: CMS Agency
    'portfolio.case4.badge': 'CMS Platform',
    'portfolio.case4.title': 'Modular CMS for Interactive Agency',
    'portfolio.case4.challenge': 'Long development time for custom client sites and difficulties managing multiple instances.',
    'portfolio.case4.solution': 'Proprietary modular CMS allowing site building from ready-made blocks with a central management panel.',
    'portfolio.case4.result1': 'Reduced site deployment time from days to hours',
    'portfolio.case4.result2': 'Easy management of 30+ sites from one place',
    'portfolio.case4.result3': 'Automated SEO and content optimization',

    // Case 5: Investment PWA
    'portfolio.case5.badge': 'FinTech PWA',
    'portfolio.case5.title': 'Investment Platform PWA',
    'portfolio.case5.challenge': 'Streamlining investor onboarding, document handling, and payments (including cryptocurrencies).',
    'portfolio.case5.solution': 'PWA application (Symfony + Angular) with automated KYC, payment processing, and investor dashboard.',
    'portfolio.case5.result1': 'Full automation of investor service',
    'portfolio.case5.result2': 'Secure BTC and fiat payment processing',
    'portfolio.case5.result3': 'Accessible on any device (mobile/desktop)',

    // Case 6: Medical E-commerce
    'portfolio.case6.badge': 'Medical E-commerce',
    'portfolio.case6.title': 'Medical Store with NFZ Integration',
    'portfolio.case6.challenge': 'Specific requirements for selling medical devices, NFZ reimbursement handling, and ERP integration.',
    'portfolio.case6.solution': 'Dedicated Sylius implementation with reimbursement modules and two-way ERP synchronization.',
    'portfolio.case6.result1': 'Automated NFZ reimbursement processes',
    'portfolio.case6.result2': 'Full stock and order integration with ERP',
    'portfolio.case6.result3': 'Compliance with strict legal requirements',

    // Case 7: Mailing System
    'portfolio.case7.badge': 'High-Load System',
    'portfolio.case7.title': 'Mass Mailing System',
    'portfolio.case7.challenge': 'Performance issues sending millions of messages, legacy technology, and slow reporting.',
    'portfolio.case7.solution': 'Modernization to PHP 7, database optimization, and introduction of advanced sending queues.',
    'portfolio.case7.result1': 'Stable handling of campaigns >1M recipients',
    'portfolio.case7.result2': 'Real-time statistics reporting',
    'portfolio.case7.result3': 'Significant reduction in server load',

    // Case 8: AdTech
    'portfolio.case8.badge': 'AdTech & Big Data',
    'portfolio.case8.title': 'Ad Campaign Management & Analytics Platform',
    'portfolio.case8.challenge': 'Aggregating and analyzing massive amounts of advertising event data from multiple sources in real-time.',
    'portfolio.case8.solution': 'Scalable platform based on Hadoop and Solr for Big Data processing and ad exchange integrations.',
    'portfolio.case8.result1': 'Processing tens of millions of events daily',
    'portfolio.case8.result2': 'Precise ad targeting',
    'portfolio.case8.result3': 'Real-time budget optimization',

    // Filters
    'portfolio.filter.all': 'All',
    'portfolio.filter.backend': 'Backend',
    'portfolio.filter.frontend': 'Frontend',
    'portfolio.filter.mobile': 'Mobile',
    'portfolio.filter.database': 'Databases',
    'portfolio.filter.ecommerce': 'E-commerce',

    // Workflow
    'workflow.label': 'Process',
    'workflow.heading': 'How I Work',
    'workflow.description': 'Proven project delivery process — from analysis to deployment and support',
    'workflow.step1.title': 'Analysis & Requirements',
    'workflow.step1.desc': 'Client meeting, understanding business goals, process and data flow analysis.',
    'workflow.step1.output': '→ Requirements document + functional plan',
    'workflow.step2.title': 'Architecture Design',
    'workflow.step2.desc': 'Technology selection, database structure design, API and module planning.',
    'workflow.step2.output': '→ System architecture + technical backlog',
    'workflow.step3.title': 'Implementation',
    'workflow.step3.desc': 'Backend and API development, UI building, third-party integrations.',
    'workflow.step3.output': '→ Working application version (MVP)',
    'workflow.step4.title': 'Testing & Optimization',
    'workflow.step4.desc': 'Manual and automated testing, performance testing, fixes and optimizations.',
    'workflow.step4.output': '→ Stable production version',
    'workflow.step5.title': 'Deployment',
    'workflow.step5.desc': 'Environment configuration, data migrations, application launch, monitoring.',
    'workflow.step5.output': '→ Application available to users',
    'workflow.step6.title': 'Maintenance & Growth',
    'workflow.step6.desc': 'Fixes and updates, new feature development, data analysis and optimization.',
    'workflow.step6.output': '→ System growing with the business',

    // Services
    'services.label': 'Services',
    'services.heading': 'What I Offer',
    'services.description': 'Comprehensive development services tailored to your business needs',
    'services.webapp.title': 'Web Applications',
    'services.webapp.desc': 'Custom CMS, CRM, admin panels and business applications tailored to your needs.',
    'services.api.title': 'API Development',
    'services.api.desc': 'RESTful API and GraphQL for system communication, platform integrations.',
    'services.integration.title': 'System Integrations',
    'services.integration.desc': 'Connecting existing tools, data synchronization, workflow automation.',
    'services.mobile.title': 'Mobile Applications',
    'services.mobile.desc': 'Cross-platform iOS and Android apps in Flutter from a single codebase.',
    'services.automation.title': 'Process Automation',
    'services.automation.desc': 'Scripts and tools automating repetitive tasks and streamlining workflows.',
    'services.consulting.title': 'Technical Consulting',
    'services.consulting.desc': 'Architecture analysis, code review, technology selection, IT project planning.',

    // Footer
    'footer.text': '© 2025 Marcin Galej. All rights reserved.',
    'footer.console.status': '"Ready for action"'
  }
};
